import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { clientsApi } from '~/store/apis/endpoints/myPages/clients/clients.api';
import { Company } from '~/models/clients/company';
import { ClientInfo } from '~/models/clients/clientBase';

export interface ClientState {
  clientId?: number;
  info?: ClientInfo;
  activeCompany?: Company;
  companies?: Company[];
}

const initialState: ClientState = {};

const clientSlice = createSlice({
  name: 'client',
  initialState,
  reducers: {
    updateActiveCompany: (state, action: PayloadAction<Company>) => {
      state.activeCompany = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      clientsApi.endpoints.getClient.matchFulfilled,
      (state, { payload: { language, id, ...rest } }) => ({
        ...state,
        ...rest,
        clientId: id,
      })
    );
  },
});

export const { updateActiveCompany } = clientSlice.actions;

export default clientSlice.reducer;
